import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PhotoViewerService {
  openImageViewer = false;
  imageObservable = new BehaviorSubject([]);
  image = this.imageObservable.asObservable();

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  toggle() {
    this.openImageViewer = !this.openImageViewer;
    this.update.emit(this.openImageViewer);
  }

  setImage(image) {
    this.imageObservable.next(image);
  }
}
